export default "__VITE_ASSET__CJvjohAN__"